var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.898438C2.91015 0.898438 0 3.80858 0 7.39844C0 10.9883 2.91015 13.8984 6.5 13.8984C10.0899 13.8984 13 10.9883 13 7.39844C13 3.80858 10.0899 0.898438 6.5 0.898438ZM6.5 3.63349C7.54508 3.63349 8.49027 4.05988 9.17237 4.7475L10.265 3.96991V7.47699L6.90863 6.35821L7.89729 5.65441C7.51455 5.34653 7.0295 5.16169 6.50002 5.16169C5.2647 5.16169 4.26326 6.1631 4.26326 7.39845C4.26326 8.63379 5.26468 9.6352 6.5 9.6352C7.32905 9.6352 8.05127 9.18335 8.43762 8.51326L9.76267 9.27498C9.11244 10.403 7.89556 11.1634 6.5 11.1634C4.42074 11.1634 2.73505 9.47768 2.73505 7.39844C2.73505 5.3192 4.42074 3.63349 6.5 3.63349Z",
    fill: "#8692A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.f1167c4b82a7c7592bb9f8e59cc70dc1.svg";
export { ForwardRef as ReactComponent };